import { render, staticRenderFns } from "./customerOfHealth.vue?vue&type=template&id=de86828c&scoped=true&"
import script from "./customerOfHealth.vue?vue&type=script&lang=js&"
export * from "./customerOfHealth.vue?vue&type=script&lang=js&"
import style0 from "./customerOfHealth.vue?vue&type=style&index=0&id=de86828c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de86828c",
  null
  
)

export default component.exports